import { useTracking } from '@repo/tracking/use-tracking';
import { useTranslation } from '@repo/translations/use-translation';

import { ButtonAnchor, ModalBody, ModalFooter, ModalWrapper } from '@zooplus/ui-components';

import RenewOfferIcon from './add-premium.svg';
import styles from './PremiumAddedModal.module.css';

export type RenewModalProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  isCartEmpty: boolean;
};

export const PremiumAddedModal = ({ isOpen, setIsOpen, isCartEmpty }: RenewModalProps) => {
  const { t } = useTranslation();
  const { trackClick } = useTracking();

  return (
    <ModalWrapper
      closeBtnAriaLabel={t('loyalty-program.renew-membership-modal.close-label')}
      heading={'\u200B'}
      title={t('loyalty-program.renew-membership-modal.title')}
      isOpen={isOpen}
      headingId="renewal-modal"
      onClose={() => setIsOpen(false)}>
      <ModalBody className={styles.content}>
        <RenewOfferIcon aria-hidden />
        <div>
          <h3 className={styles.title}>{t('loyalty-program.renew-membership-modal.title')}</h3>
          <p className={styles.subtitle}>
            {isCartEmpty
              ? t('loyalty-program.renew-membership-modal.empty-cart.subtitle')
              : t('loyalty-program.renew-membership-modal.items-in-cart.subtitle')}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonAnchor
          onClick={() => {
            trackClick({
              target: {
                name: 'add_premium_modal',
                id: 'add_membership_to_cart',
              },
            });
          }}
          href={`${isCartEmpty ? '/' : '/checkout/cart'}`}>
          {isCartEmpty
            ? t('loyalty-program.renew-membership-modal.empty-cart.continue-shopping-button')
            : t('loyalty-program.renew-membership-modal.items-in-cart.go-to-basket-button')}
        </ButtonAnchor>
      </ModalFooter>
    </ModalWrapper>
  );
};
